import { render } from "./pageDangj.vue?vue&type=template&id=7f182dcc&scoped=true"
import script from "./pageDangj.vue?vue&type=script&lang=js"
export * from "./pageDangj.vue?vue&type=script&lang=js"

import "./pageDangj.vue?vue&type=style&index=0&id=7f182dcc&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f182dcc"]])

export default __exports__